import { Paper } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import classnames from "classnames";
import * as React from "react";

import { RelodeTheme } from "../";
import { combineStyles } from "../styles/combineStyles";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                width: "100%",
            },
            content: {
                padding: theme.spacing(2),
            },
            noPaper: {
                padding: 0,
                backgroundColor: "transparent",
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(135px, 1fr))",
                justifyContent: "space-between",
                gridGap: "32px",
                width: "100%",

                [theme.breakpoints.down("md")]: {
                    flexDirection: "column",
                    display: "flex",
                    rowGap: "24px",
                    width: "100%",
                },
            },
            paper: {
                height: "100%",
                boxShadow: "0 2px 4px 0 rgba(0,0,0,0.1)",
            },
        }),
    { name: "TilesSection" }
);

interface Props {
    children?: React.ReactNode;
    classes?: any;
    id?: any;
    usePaper?: boolean;
    className?: string;
}

export const TilesSection = (props: Props) => {
    const classes = combineStyles(useStyles({}), props.classes);
    const rootClass = classnames(classes.root, {
        [props.className]: !!props.className,
    });
    const contentClass = classnames({
        [classes.content]: true,
        [classes.noPaper]: !props.usePaper,
    });

    return (
        <div className={rootClass} id={props.id}>
            <Paper
                elevation={!!props.usePaper ? 1 : 0}
                className={contentClass}
                classes={!!props.usePaper ? { root: classes.paper } : null}
            >
                {props.children}
            </Paper>
        </div>
    );
};
